import Input from "src/components/inputs/Input";
import SensitiveTextarea from "src/components/inputs/SensitiveTextarea";
import ConnectionStatusBlock from "./ConnectionStatusBlock";

interface CernerConfigTabProps {
  baseOauthUrl: string;
  onBaseOauthUrlChange: (value: string) => void;
  cernerClientId: string;
  onCernerClientIdChange: (value: string) => void;
  cernerClientSecret: string;
  onCernerClientSecretChange: (value: string) => void;
  cernerSystemId: string;
  onCernerSystemIdChange: (value: string) => void;
  cernerOrganizationId: string;
  onCernerOrganizationIdChange: (value: string) => void;
  connectionStatus: boolean | null;
  isTestingConnection: boolean;
  isLoadingConnectionStatus: boolean;
  disableInputs: boolean;
  onTestConnection: () => Promise<void>;
}

const CernerConfigTab = ({
  baseOauthUrl,
  onBaseOauthUrlChange,
  cernerClientId,
  onCernerClientIdChange,
  cernerClientSecret,
  onCernerClientSecretChange,
  cernerSystemId,
  onCernerSystemIdChange,
  cernerOrganizationId,
  onCernerOrganizationIdChange,
  connectionStatus,
  isTestingConnection,
  isLoadingConnectionStatus,
  disableInputs,
  onTestConnection,
}: CernerConfigTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">Cerner Configuration</h3>
    <ConnectionStatusBlock
      connectionStatus={connectionStatus}
      isTestingConnection={isTestingConnection}
      isLoadingConnectionStatus={isLoadingConnectionStatus}
    />
    <div className="flex gap-4 mb-4">
      <button
        type="button"
        disabled={disableInputs || isTestingConnection}
        onClick={() => onTestConnection()}
        className="max-w-xs w-full bg-brand-600 hover:bg-brand-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
      >
        {isTestingConnection ? "Testing..." : "Test Connection"}
      </button>
    </div>
    <Input
      type="text"
      label="Client ID"
      placeholder="Enter Client ID"
      value={cernerClientId}
      onChange={(e) => onCernerClientIdChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
    <SensitiveTextarea
      label="Client Secret"
      placeholder="Enter Client Secret"
      value={cernerClientSecret}
      onChange={onCernerClientSecretChange}
      required={false}
      disabled={disableInputs}
    />
    <Input
      type="text"
      label="System ID"
      placeholder="Enter System ID"
      value={cernerSystemId}
      onChange={(e) => onCernerSystemIdChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
    <Input
      type="text"
      label="Organization ID"
      placeholder="Enter Organization ID"
      value={cernerOrganizationId}
      onChange={(e) => onCernerOrganizationIdChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
    <Input
      type="text"
      label="Base OAuth URL"
      placeholder="Enter Base OAuth URL"
      value={baseOauthUrl}
      onChange={(e) => onBaseOauthUrlChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
  </>
);

export default CernerConfigTab;
